// live.syqel.com analytics — the locked pair: GA4 for campaign/ads
// measurement, PostHog for product events. Explicit events only; no
// autocapture, no session recording, no cookies of our own (PostHog id
// lives in localStorage).
//
// GA4 = the syqel.com property (Yoav's call: live.syqel.com measures into
// the same campaign property). Loads in prod builds only.

const GA_ID = 'G-RXLGFQ8Q3C';
const PH_HOST = 'https://us.i.posthog.com';
// The dedicated "SYQEL Live" PostHog project (id 523842; public write key).
const PH_KEY = 'phc_rssPVA9fjP2xaEzX86tcFWnwQJjxJU3sJBAW93tRFW6s';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

function distinctId(): string {
  const KEY = 'syqel.preview.id';
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(KEY, id);
  }
  return id;
}

/** Load GA4 (prod only, and only once an id exists) + fire the page view. */
export function initAnalytics(): void {
  if (GA_ID && import.meta.env.PROD) {
    window.dataLayer = window.dataLayer ?? [];
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer!.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_ID);
    const s = document.createElement('script');
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(s);
  }
  track('preview_opened', {
    webgl2: document.createElement('canvas').getContext('webgl2') !== null,
  });
}

/** One event to both sinks. keepalive so CTA clicks survive navigation. */
export function track(event: string, props: Record<string, unknown> = {}): void {
  window.gtag?.('event', event, props);
  try {
    void fetch(`${PH_HOST}/capture/`, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        api_key: PH_KEY,
        event,
        distinct_id: distinctId(),
        properties: { app: 'syqel-live-preview', ...props },
      }),
    }).catch(() => undefined);
  } catch {
    // storage/fetch unavailable (private mode edge cases) — analytics never breaks the preview
  }
}
